import { CustomizationType } from '../contexts/BrandingContext';
import API from './api';

export const getLicenseStatus = async (): Promise<{
  clientName: string;
  maxUsers: number;
  expireDate: string;
  issuedAt: string;
  daysRemaining: number;
}> => {
  const response = await API().get('/license/status');
  return response.data.data;
};

export const getLicenseCustomization = async (): Promise<CustomizationType> => {
  const response = await API().get('/license/customization');
  return response.data;
};
